import * as React from 'react';
import {useEffect, useState} from 'react';
import {Form, ListGroup, Nav, Navbar, NavDropdown, Offcanvas, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {EnumPlanObdobi, FulltextApi, FulltextResult, HelpVO, OptionsVO, SettingsApi, VerzeVO} from '../api';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons';
import {useHistory} from 'react-router';
import {getFormattedNumber} from '../utils/NumberUtils';
import {SKUTECNOST} from '../enums/PohledTypeEnum';
import {AppIcon} from '../icons/AppIcon';
import {faCircleQuestion} from '@fortawesome/free-regular-svg-icons';

type Props = {
    page: string;
    idVerze: string;
    idStrom?: string;
    planObdobi: string;
};

export const AppNavbar: React.FC<Props> = ({page, idVerze, idStrom, planObdobi}) => {
    const [appLabel, setAppLabel] = useState<string>();
    const [helpUrl, setHelpUrl] = useState<string>();
    const [verze, setVerze] = useState<VerzeVO[]>([]);
    const [selectedVersion, setSelectedVersion] = useState<number>();

    const [show, setShow] = useState(false);
    const [fulltext, setFulltext] = useState('');
    const [fulltextRes, setFulltextRes] = useState<FulltextResult[]>([]);

    const history = useHistory();

    const changeVerze = (ver: number | undefined) => {
        setSelectedVersion(ver);
        const verzeVO = verze.find(item => item.rok === ver);
        if (verzeVO) {
            switch (page) {
                case 'souhrn':
                    history.replace('/souhrn/' + verzeVO.idPlanVerze);
                    break;
                case 'strom':
                    if (idStrom) {
                        history.replace('/strom/' + verzeVO.idPlanVerze + '/' + idStrom);
                    } else {
                        history.replace('/strom/' + verzeVO.idPlanVerze);
                    }
                    break;
                case 'statistika':
                    history.replace('/statistika/' + verzeVO.idPlanVerze);
                    break;
            }
        }
    };

    const handleClose = () => setShow(false);

    useEffect(() => {
        loadOptions();
        loadHelp();
    }, [appLabel]);

    const loadOptions = () => {
        const fetchData = async () => {
            let data: OptionsVO;
            try {
                data = (await SettingsApi.getNavbarOptions()).data;
                if (data.verze) {
                    setVerze(data.verze);
                    if (idVerze) {
                        const verzeVO = data.verze.find(item => item.idPlanVerze === parseInt(idVerze));
                        if (verzeVO && verzeVO.rok) {
                            changeVerze(verzeVO.rok);
                        }
                    } else {
                        changeVerze(data.verze[0].rok);
                    }
                }
                if (!appLabel && appLabel !== '') {
                    setAppLabel(data.label ? data.label : '');
                }
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    const loadHelp = () => {
        const fetchData = async () => {
            let data: HelpVO;
            try {
                data = (await SettingsApi.getHelp()).data;
                if (!helpUrl && helpUrl !== '') {
                    setHelpUrl(data.helpUrl ? data.helpUrl : '');
                }
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    const onInputchange = (event: any) => {
        const value = event.target.value;
        setFulltext(value);
        const fetchData = async () => {
            let data: FulltextResult[];
            try {
                if (value.length > 2) {
                    const verzeVO = verze.find(item => item.rok === selectedVersion);
                    if (verzeVO && verzeVO.idPlanVerze) {
                        const obdobiEnum = planObdobi === SKUTECNOST ? EnumPlanObdobi.SKUTECNOST : EnumPlanObdobi.PLAN;
                        data = (await FulltextApi.searchByFulltext(value, verzeVO.idPlanVerze, obdobiEnum)).data;
                        setFulltextRes(data);
                    }
                }
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    const onClick = (idPlanVerze: number | undefined, idPlan: number | undefined) => {
        history.push('/strom/' + idPlanVerze + '/' + idPlan);
        setShow(false);
    };

    return (
        <div>
            <Navbar variant="dark" expand="lg" style={{backgroundColor: 'rgb(0,27,77)', paddingLeft: 10}}>
                <Navbar.Brand className="touchable" style={{marginRight: 0}} onClick={() => history.push('/souhrn/' + idVerze)}>
                    <div style={{display: 'flex'}}>
                        <div>
                            <AppIcon />
                        </div>
                        <div style={{marginLeft: 10}}>{appLabel}</div>
                    </div>
                </Navbar.Brand>

                <Nav className="me-auto">
                    <NavDropdown title={selectedVersion} className={'nav-text'} id="nav-dropdown">
                        {verze.map(verze => {
                            return (
                                <NavDropdown.Item key={verze.rok} onClick={() => changeVerze(verze.rok)}>
                                    {verze.rok}
                                </NavDropdown.Item>
                            );
                        })}
                    </NavDropdown>
                </Nav>
                <Nav className={'nav-text'}>
                    { helpUrl && helpUrl !== '' &&
                        <a href={helpUrl} style={{paddingRight: 20}} target="_blank" rel="noreferrer" aria-label="Nápověda">
                            <FontAwesomeIcon icon={faCircleQuestion} color={'white'} aria-hidden={true} />
                        </a>
                    }
                    <span className="touchable" onClick={() => setShow(true)} style={{paddingRight: 20}}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} color={'white'} /> Hledat
                    </span>
                </Nav>
            </Navbar>
            <Offcanvas show={show} onHide={handleClose} placement={'end'}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <div className="input-group" style={{alignItems: 'center'}}>
                            Hledání
                            <Form.Control type="text" placeholder="vyhledat..." value={fulltext} onChange={onInputchange} style={{marginLeft: 10}} autoFocus />
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {fulltextRes.length > 0 && (
                        <ListGroup>
                            {fulltextRes.map(result => {
                                const nazev = result.nazev
                                    ? result.nazev.length > 34
                                        ? result.nazev.substring(0, 34).trim() + '...'
                                        : result.nazev
                                    : undefined;
                                const popis = result.popis
                                    ? result.popis.length > 34
                                        ? result.popis.substring(0, 34).trim() + '...'
                                        : result.popis
                                    : undefined;
                                return (
                                    <div key={result.idPlan}>
                                        <ListGroup.Item action onClick={() => onClick(result.idPlanVerze, result.idPlan)}>
                                            <div className="ms-2 me-auto">
                                                <div className="fw-bold">{nazev}</div>
                                                <div>{'(' + getFormattedNumber(result.castka) + ' tis. Kč)'}</div>
                                                {popis && (
                                                    <OverlayTrigger placement={'top'} overlay={<Tooltip>{result.popis}</Tooltip>}>
                                                        <div>{popis}</div>
                                                    </OverlayTrigger>
                                                )}
                                            </div>
                                        </ListGroup.Item>
                                    </div>
                                );
                            })}
                        </ListGroup>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};
